import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { useCases } from '../../data/content';

/** Section 8 — different ways to teach with it. */
export function UseCasesSection() {
  return <section aria-labelledby="usecases-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-252" data-mp="12sjnwb8o65qk">
      <div className="mx-auto max-w-5xl" data-id="element-253" data-mp="xvbep05i1c1g">
        <SectionHeading id="usecases-heading" title={<>
              One System. <Accent data-id="element-255" data-mp="1vjuy4ec9kymn">Different Ways to Teach.</Accent>
            </>} data-id="element-254" data-mp="xwcs3b9zmamc" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-256" data-mp="1ql0hnj1rrm5p">
          {useCases.map(({
          icon: Icon,
          title,
          description
        }) => <li key={title} className="flex h-full flex-col rounded-[20px] bg-brand-lavender px-6 py-7" data-id="element-257" data-mp="1gtw0qdsj9r88">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-brand-plum" data-id="element-258" data-mp="2e9jorv931sw7">
                <Icon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-259" data-mp="29h030b08rrgb" />
              </span>
              <h3 className="mt-5 font-body text-[13px] font-bold uppercase tracking-[0.12em] text-brand-charcoal" data-id="element-260" data-mp="vdr17zgneqfb">
                {title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-261" data-mp="lnxq0zkf4dbl">{description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}